import BaseTable from '@material-ui/core/Table'

const Table = BaseTable

export default Table
